import React from 'react'
import { withTheme } from 'styled-components'

import Icon, { IconNames } from 'components/icons'

import { LegLabel, LegTitleWrapper } from '../styled'

const MultidestinyHeader = ({ mobileOrTablet, title, isExpanded, handleClick, theme }) => (
  <LegTitleWrapper onClick={handleClick}>
    <LegLabel>{title}</LegLabel>
    {mobileOrTablet && (
      <Icon
        name={IconNames[isExpanded ? IconNames.ChevronUp : IconNames.ChevronDown]}
        size={26}
        color={theme.colors.blue}
      />
    )}
  </LegTitleWrapper>
)

export default withTheme(MultidestinyHeader)
